import { cn } from '../../lib/cn';
import type { ApprovalRow } from '../../mobilecompanion/framework';

type Props = { approvals?: ApprovalRow[] };

export function ExecutiveApprovalsPanel({ approvals = [] }: Props) {
  return (
    <div className="space-y-2">
      {approvals.map((a) => (
        <div key={a.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{a.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{a.type} · {a.amount} · waiting {a.waiting}</p>
          </div>
          <span className={cn(
            'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
            a.priority === 'high' ? 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300' :
            'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300',
          )}>
            {a.priority}
          </span>
        </div>
      ))}
    </div>
  );
}
